import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Polityka = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden">
      {/* Navigation */}
      <motion.nav
        className="fixed top-0 left-0 right-0 z-50 glass-effect"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <a href="/">
              <img
                src="/images/logominitgps.png"
                alt="MonitGPS Logo"
                className="h-12 w-auto cursor-pointer"
              />
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8 text-sm font-medium">
            <a href="/" className="hover:text-cyan-400 transition-colors">Strona Główna</a>
            <a href="/zawodnik" className="hover:text-cyan-400 transition-colors">Strona Zawodnika</a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-cyan-400 focus:outline-none">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#0a0a0a]/95 border-b border-white/10 flex flex-col px-6 py-4 space-y-4 text-sm font-medium backdrop-blur-xl">
            <a href="/" className="hover:text-cyan-400">Strona Główna</a>
            <a href="/zawodnik" className="hover:text-cyan-400">Strona Zawodnika</a>
          </div>
        )}
      </motion.nav>

      {/* Content */}
      <section className="relative pt-32 pb-24 px-6 min-h-[70vh]">
        <div className="max-w-4xl mx-auto glass-effect rounded-3xl p-8 md:p-12">
          <h1 className="font-display font-black text-4xl md:text-5xl mb-8 text-cyan-400">
            Polityka <span className="text-white">Prywatności</span>
          </h1>
          
          <div className="space-y-8 text-gray-300 leading-relaxed font-light">
            <div>
              <h2 className="text-xl text-white font-bold mb-3">1. Informacje ogólne</h2>
              <p>
                Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych przekazanych przez Użytkowników w związku z korzystaniem z usług MonitGPS oraz witryny internetowej monitgps.pl.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">2. Administrator Danych Osobowych</h2>
              <p>
                Administratorem Państwa danych osobowych jest system MonitGPS z siedzibą w Polsce (dane kontaktowe dostępne w sekcji Kontakt).
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">3. Zbieranie Danych</h2>
              <p>
                Serwis realizuje funkcje pozyskiwania informacji o użytkownikach na skutek wprowadzania informacji dobrowolnie, w tym w szczególności podczas korzystania z formularza do zamówień sprzętu, podpisywania oświadczeń dla Szkoleń E-learningowych, oraz kontaktów bezpośrednich z obsługą MonitGPS.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">4. Cel i Podstawa Prawna</h2>
              <p>
                Dane osobowe są wykorzystywane do celów świadczenia usług systemu, komunikacji w sprawach organizacyjnych, monitorowania zawodników oraz dokumentowania przejścia obowiązkowych szkoleń. Podstawą prawną jest świadczenie umowy wynajmu systemów monitoringu we współpracy z organizatorami rajdów.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">5. Udostępnianie Danych</h2>
              <p>
                Dane nie są profilowane, sprzedawane stronom trzecim ani wykorzystywane do celów marketingowych bez wyraźnej zgody użytkownika. Dostęp do niektórych danych, pod nadzorem prawnym, mogą uzyskiwać organizatorzy imprez motorowych bezpośrednio połączonych z Twoim uczestnictwem z systemem MonitGPS.
              </p>
            </div>
            
            <div>
              <h2 className="text-xl text-white font-bold mb-3">6. Prawa Użytkownika</h2>
              <p>
                Użytkownik ma prawo do wglądu w swoje dane, ich usunięcia i możliwości żądania zaprzestania ich przetwarzania w każdym momencie. Z prośbą o usunięcie informacji prosimy kontaktować się przez e-mail pisząc na kontakt@monitgps.pl.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-6 glass-effect border-t border-white/5 mt-auto">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <p>© 2024 MonitGPS. Wszystkie prawa zastrzeżone.</p>
            <a href="/polityka-prywatnosci" className="hover:text-cyan-400 transition-colors underline decoration-white/20 underline-offset-4">Polityka Prywatności</a>
          </div>
          <div className="mt-4 md:mt-0">
            <p>Profesjonalny monitoring dla sportów motorowych</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Polityka;
